import { render, staticRenderFns } from "./PickUpSetting.vue?vue&type=template&id=16847a0c&scoped=true&"
import script from "./PickUpSetting.vue?vue&type=script&lang=js&"
export * from "./PickUpSetting.vue?vue&type=script&lang=js&"
import style0 from "./PickUpSetting.vue?vue&type=style&index=0&id=16847a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16847a0c",
  null
  
)

export default component.exports